import dateHelper from '@/services/date';
import i18n from '@/i18n';

const charts = {};
const types = ['visitors', 'conversions'];

charts.colors = ['#85bdd7', '#a99bc8'];

charts.getChartsTypes = () => types.map((type, index) => (
  { type, color: charts.colors[index], visible: true }),
);

charts.keys = {
  x: 'period',
  value: types,
};

const getFormatByGranularity = granularity => i18n.t(`chart.granularity.${granularity}.format`);

charts.formatPeriod = (period, granularity) => dateHelper.formatedDate(period, getFormatByGranularity(granularity), granularity === 'day');

export default charts;



// WEBPACK FOOTER //
// ./src/helpers/charts.js